import React from "react";
import Alert from "@material-ui/lab/Alert";
import { Snackbar } from "@material-ui/core";
import {useFeedback} from "../utils/FeedbackContext";

export default () => {

    const feedback = useFeedback();

    return (
    <Snackbar
        open={feedback.open}
        autoHideDuration={feedback.time}
        onClose={feedback.closeType}
    >
        <Alert
            elevation={6} 
            onClose={feedback.closeType}
            severity={feedback.severity}
            >
            {feedback.message}
        </Alert>
        
    </Snackbar>
)


}